import { useTranslation } from 'react-i18next';

import { Classroom } from '../../../../modules/classroom';
import { ClassSelectCard } from '../../components/class-select-card';
import { useJoinToClassroom } from '../../join-to-classroom-context';
import {
  BlockTitle,
  ClassesToAssign,
  ClassroomsPerCourse,
  Container,
  CourseBlocks,
} from '../../join-to-classroom.styled';

function ConfirmJourneysStep(): JSX.Element {
  const { t } = useTranslation();
  const { selectedClassrooms, alreadyJoinedClassrooms, openEditModal } =
    useJoinToClassroom();

  return (
    <Container>
      <CourseBlocks>
        <BlockTitle>
          {t('classrooms.steps.confirm-journeys.subtitle')}
        </BlockTitle>
        <ClassesToAssign>
          {selectedClassrooms.length > 0 ? (
            <ClassroomsPerCourse>
              {selectedClassrooms.map((classroom) => (
                <ClassSelectCard
                  key={`card-${classroom.id}`}
                  classroom={classroom as Classroom}
                  status={'default'}
                  onClickEdit={() => openEditModal(classroom as Classroom)}
                />
              ))}
            </ClassroomsPerCourse>
          ) : (
            <BlockTitle>
              {t('classrooms.steps.confirm-journeys.no-journeys')}
            </BlockTitle>
          )}
        </ClassesToAssign>
      </CourseBlocks>
      {alreadyJoinedClassrooms?.length > 0 && (
        <CourseBlocks>
          <BlockTitle>
            {t('classrooms.select-classrooms.confirm.description')}
          </BlockTitle>
          <ClassroomsPerCourse>
            {alreadyJoinedClassrooms.map((classroom: Classroom) => (
              <ClassSelectCard
                key={`card-${classroom.id}`}
                classroom={classroom}
                onClickEdit={() => openEditModal(classroom)}
              />
            ))}
          </ClassroomsPerCourse>
        </CourseBlocks>
      )}
    </Container>
  );
}

export { ConfirmJourneysStep };
